module.exports = __webpack_public_path__ + "static/media/coriander.32767fc1.jpg";